/* Tres Vera homepage gedrag. Hoort bij sections/tv-home-v4.liquid en assets/tvh2.css.
   Stond tot 14 oktober 2026 los in Shopify Files, nu in het theme en dus in git. */

/* 1. Announcement bar: oranje balk met lopende tekst. Drie berichten, elk waar,
      dubbel in de rij zodat de lus naadloos doorloopt. */
(function () {
  var mq = document.getElementById('mq');
  if (!mq) return;
  /* De teksten staan per taal in locales/*.json (tv.js.*) en komen via window.tvT,
     gezet in layout/theme.liquid. */
  var T = window.tvT || {};
  var items = T.announce || [];
  mq.innerHTML = items.concat(items).concat(items).concat(items)
    .map(function (s) { return '<span>' + s + '</span>'; }).join('');
  /* 16 okt: pauzeknop. Stilzetten blijft gelden zolang je op de site bent. */
  var bar = mq.parentNode, knop = document.getElementById('mqpauze');
  function zet(stil) {
    bar.classList.toggle('tvzmq-stil', stil);
    if (knop) { knop.setAttribute('aria-pressed', stil ? 'true' : 'false'); knop.setAttribute('aria-label', stil ? (T.mq_play || '') : (T.mq_pause || '')); knop.classList.toggle('tvzis-stil', stil); }
    try { sessionStorage.setItem('tvzmq-stil', stil ? '1' : ''); } catch (e) {}
  }
  var bewaard = ''; try { bewaard = sessionStorage.getItem('tvzmq-stil') || ''; } catch (e) {}
  if (bewaard) zet(true);
  if (knop) knop.addEventListener('click', function () { zet(!bar.classList.contains('tvzmq-stil')); });
})();

/* 2. Header die vast komt te staan en de koopbalk onderaan. */
(function () {
  var head = document.getElementById('head');
  var buybar = document.getElementById('buybar');
  if (!head) return;
  function onScroll() {
    var y = window.scrollY;
    head.classList.toggle('tvzsolid', y > 40);
    if (buybar) buybar.classList.toggle('tvzshow', y > window.innerHeight * 0.9);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* 3. Secties die rustig in beeld komen, en de prijsbalken die zich vullen. */
(function () {
  var obs = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('tvzin');
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.tvzreveal').forEach(function (el) { obs.observe(el); });

  /* De prijsbalken vullen zich zodra ze in beeld komen. Keek eerst alleen naar
     #bars op de homepage; sinds de productpagina dezelfde vergelijking toont,
     kijkt hij naar elk blok met data-tvzbars en vult alleen de balken daarbinnen. */
  var balkblokken = document.querySelectorAll('#bars, [data-tvzbars]');
  if (!balkblokken.length) return;
  var barObs = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.querySelectorAll('.tvzfill').forEach(function (f) {
        f.style.width = f.getAttribute('data-w') + '%';
      });
      barObs.unobserve(e.target);
    });
  }, { threshold: 0.3 });
  balkblokken.forEach(function (b) { barObs.observe(b); });
})();

/* 4. Het menu. */
(function () {
  var ov = document.getElementById('overlay');
  var dr = document.getElementById('drawer');
  var burger = document.getElementById('burger');
  var close = document.getElementById('closeMenu');
  if (!ov || !dr || !burger) return;
  function openM() {
    ov.classList.add('tvzis-open');
    dr.classList.add('tvzis-open');
    document.body.classList.add('tvzmenu-open');
  }
  function closeM() {
    ov.classList.remove('tvzis-open');
    dr.classList.remove('tvzis-open');
    document.body.classList.remove('tvzmenu-open');
  }
  burger.addEventListener('click', openM);
  if (close) close.addEventListener('click', closeM);
  ov.addEventListener('click', closeM);
  document.querySelectorAll('.tvzdrawer nav a').forEach(function (a) {
    a.addEventListener('click', closeM);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeM();
  });
})();

/* 4b. Vervagen van de pagina achter een venster.

      Waarom niet met backdrop-filter: dat vervaagt alleen wat er toevallig
      achter het doek zit, en het faalt stil zodra een voorouder een transform
      of filter heeft. Dat is precies wat hier gebeurde: het doek stond goed in
      de CSS, maar je zag er niets van.

      Dit werkt anders en altijd: de pop-up wordt uit de pagina getild en
      rechtstreeks aan body gehangen, en daarna krijgt alles wat nog in body
      zit een filter. De pop-up valt daar dan buiten en blijft scherp.

      Let op: een element met een filter wordt een nieuw ankerpunt voor
      position:fixed. Daarom moet de pop-up er echt buiten hangen; binnen de
      pagina laten staan werkt niet. */
function tvzVervaag(modal, aan) {
  if (aan) {
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    document.documentElement.classList.add('tvz-dim');
  } else {
    document.documentElement.classList.remove('tvz-dim');
  }
}

/* 5. Pop-up "Houd mij op de hoogte". Elke knop met data-tvzwait opent hem en
      zet de productnaam in het verborgen veld, zodat de inschrijving te herleiden is. */
(function () {
  var modal = document.getElementById('tvzwaitmodal');
  if (!modal) return;
  var nameOut = modal.querySelectorAll('[data-tvzwait-name]');
  var hidden = modal.querySelector('[data-tvzwait-product]');
  var lastFocus = null;

  /* De naam staat midden in een zin: "Zodra de gliding gel klaar is". Begint hij
     met een lidwoord, dan hoort die hoofdletter daar niet. Namen zonder lidwoord
     (Earth, Body, Zyra) blijven staan zoals ze zijn. De tag die naar Shopify gaat
     houdt wel de oorspronkelijke schrijfwijze. */
  /* Per taal: het patroon van de lidwoorden komt uit tv.js.wait_article_re
     (NL "^(De|Het) ", EN "^(The) ", ES "^(El|La|Los|Las) "). */
  var lidwoord = null;
  try { if (window.tvT && window.tvT.wait_article_re) lidwoord = new RegExp(window.tvT.wait_article_re); } catch (e) {}
  function inDeZin(naam) {
    return lidwoord && lidwoord.test(naam) ? naam.charAt(0).toLowerCase() + naam.slice(1) : naam;
  }
  /* De zichtbare naam mag per taal anders zijn dan de tag: een knop met
     data-tvzwait-label toont dat label, de tag blijft data-tvzwait. */
  function labelVoor(product) {
    var knoppen = document.querySelectorAll('[data-tvzwait]');
    for (var i = 0; i < knoppen.length; i++) {
      if (knoppen[i].getAttribute('data-tvzwait') === product && knoppen[i].getAttribute('data-tvzwait-label')) {
        return knoppen[i].getAttribute('data-tvzwait-label');
      }
    }
    return product;
  }

  function open(product) {
    lastFocus = document.activeElement;
    var zichtbaar = inDeZin(labelVoor(product));
    nameOut.forEach(function (el) { el.textContent = zichtbaar; });
    /* Twee labels: "wachtlijst" voor iedereen, plus de productnaam. Zo is later in
       Shopify of Klaviyo te zien wie op welke lijst staat. */
    /* 17 okt: en de taal, zodat een mail later in de juiste taal kan. */
    if (hidden) hidden.value = 'wachtlijst, ' + product + (hidden.getAttribute('data-taal') ? ', ' + hidden.getAttribute('data-taal') : '');
    tvzVervaag(modal, true);
    modal.classList.add('tvzis-open');
    document.body.style.overflow = 'hidden';
    var first = modal.querySelector('input[type="email"]');
    if (first) first.focus();
  }
  function close() {
    modal.classList.remove('tvzis-open');
    tvzVervaag(modal, false);
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  document.querySelectorAll('[data-tvzwait]').forEach(function (btn) {
    if (btn.tagName !== 'BUTTON' && btn.tagName !== 'A') {
      btn.setAttribute('role', 'button');
      btn.setAttribute('tabindex', '0');
    }
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      open(btn.getAttribute('data-tvzwait'));
    });
  });
  modal.querySelectorAll('[data-tvzwait-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  /* Na verzenden herlaadt Shopify de pagina en is de pop-up dicht, zodat de bezoeker
     niet ziet dat het gelukt is. We onthouden kort voor welk product hij zich opgaf
     en openen hem na het herladen opnieuw, met de bevestiging of de foutmelding. */
  var form = document.getElementById('tvzwaitform');
  if (form) form.addEventListener('submit', function () {
    try { sessionStorage.setItem('tvzwait', (hidden && hidden.value || '').replace(/^wachtlijst, /, '')); } catch (e) {}
  });
  var bewaard = null;
  try { bewaard = sessionStorage.getItem('tvzwait'); sessionStorage.removeItem('tvzwait'); } catch (e) {}
  if (bewaard && modal.querySelector('.tvzok, .tvzerr')) open(bewaard);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('tvzis-open')) close();
  });
})();

/* 6. Welkomst-pop-up. Verschijnt eenmalig, pas als de bezoeker voorbij de hero is
      en minstens zeven seconden op de pagina is. Wie hem sluit of zich inschrijft,
      krijgt hem een jaar lang niet opnieuw. Dat onthouden we in de browser zelf. */
(function () {
  var modal = document.getElementById('tvzwelcome');
  if (!modal) return;

  var SLEUTEL = 'tvz-welkom-gezien';
  try { if (localStorage.getItem(SLEUTEL)) return; } catch (e) { return; }

  var geopend = false;
  var binnen = Date.now();

  function onthoud() {
    try { localStorage.setItem(SLEUTEL, String(Date.now())); } catch (e) {}
  }
  function open() {
    if (geopend) return;
    geopend = true;
    tvzVervaag(modal, true);
    modal.classList.add('tvzis-open');
    document.body.style.overflow = 'hidden';
    onthoud();
    var veld = modal.querySelector('input[type="email"]');
    if (veld) veld.focus();
  }
  function close() {
    modal.classList.remove('tvzis-open');
    tvzVervaag(modal, false);
    document.body.style.overflow = '';
  }

  function kijk() {
    if (geopend) return;
    var voorbijHero = window.scrollY > window.innerHeight * 0.9;
    var langGenoeg = Date.now() - binnen > 7000;
    if (voorbijHero && langGenoeg) {
      open();
      window.removeEventListener('scroll', kijk);
    }
  }
  window.addEventListener('scroll', kijk, { passive: true });

  modal.querySelectorAll('[data-tvzwelcome-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  modal.addEventListener('submit', onthoud);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('tvzis-open')) close();
  });
})();

/* 7. Beleidspagina's: een opmaak voor alle zes.

      Alle beleidsteksten in de admin staan sinds 16 okt in dezelfde opmaak: nummer en
      onderwerp samen op een regel ("01 · DELIVERY AREA"), met de kop als h2 eronder.
      Die regel krijgt hier zijn klasse. De tabel die bij de oude opmaak het onderwerp
      aanvulde is weg: nagemeten op 16 okt, 47 van de 47 kopjes hebben hun onderwerp
      in de bron, en de aanvulling deed op geen enkele pagina nog iets. */

(function () {
  var body = document.querySelector('.shopify-policy__body');
  if (!body) return;

  Array.prototype.slice.call(body.querySelectorAll('p')).forEach(function (p) {
    var tekst = (p.textContent || '').trim();
    if (/^\d{1,2}[\s\u00a0]*[\u00b7\u2022]/.test(tekst)) {
      p.classList.add('tvzpoleyebrow');
    }
  });
})();

/* 8. De cookiebanner van Shopify zet de kleur van zijn knoppen als inline stijl,
      opgebouwd in zijn eigen script. Stylen via een stylesheet bleek onbetrouwbaar,
      dus zetten we het hier rechtstreeks op het element, met voorrang. De banner
      verschijnt pas later en kan opnieuw worden opgebouwd, dus we blijven kijken. */
(function () {
  var EMBER = '#DD5F1E';
  var WIT = '#FFFFFF';

  function verf(el, vulling) {
    if (!el) return;
    el.style.setProperty('background', vulling ? EMBER : 'transparent', 'important');
    el.style.setProperty('background-color', vulling ? EMBER : 'transparent', 'important');
    el.style.setProperty('color', vulling ? WIT : EMBER, 'important');
    el.style.setProperty('border', '1px solid ' + EMBER, 'important');
    el.style.setProperty('border-radius', '999px', 'important');
  }

  function zetKleuren() {
    // Accepteren springt eruit: vol ember. Weigeren is bewust ingetogen, alleen
    // een rand. Zo is de positieve keuze ook visueel de makkelijkste.
    verf(document.getElementById('shopify-pc__banner__btn-accept'), true);
    verf(document.getElementById('shopify-pc__banner__btn-decline'), false);
    verf(document.getElementById('shopify-pc__prefs__header-accept'), true);
    verf(document.getElementById('shopify-pc__prefs__header-save'), true);
    verf(document.getElementById('shopify-pc__prefs__header-decline'), false);

    // Voorkeuren beheren is geen knop maar een tekstlink.
    var beheer = document.getElementById('shopify-pc__banner__btn-manage-prefs');
    if (beheer) {
      beheer.style.setProperty('background', 'transparent', 'important');
      beheer.style.setProperty('border', '0', 'important');
      beheer.style.setProperty('color', 'var(--basalt, #2F2B26)', 'important');
      beheer.style.setProperty('text-decoration', 'underline', 'important');
      beheer.style.setProperty('text-underline-offset', '3px', 'important');
      beheer.style.setProperty('padding', '14px 6px', 'important');
      beheer.style.setProperty('border-radius', '0', 'important');
    }

    // Het kruisje stond over "save my choices" heen. Het hoort rechtsboven,
    // los van de knoppenrij.
    var kruis = document.getElementById('shopify-pc__prefs__header-close');
    if (kruis) {
      kruis.style.setProperty('position', 'absolute', 'important');
      kruis.style.setProperty('top', '14px', 'important');
      kruis.style.setProperty('right', '16px', 'important');
      kruis.style.setProperty('background', 'transparent', 'important');
      kruis.style.setProperty('border', '0', 'important');
      kruis.style.setProperty('color', '#2F2B26', 'important');
      kruis.style.setProperty('z-index', '5', 'important');
      var kop = kruis.parentElement;
      if (kop) kop.style.setProperty('position', 'relative', 'important');
      var acties = document.getElementById('shopify-pc__prefs__header-actions');
      if (acties) acties.style.setProperty('padding-right', '44px', 'important');
    }

    // Het venster moet in een keer te lezen zijn, dus het groeit mee met de tekst.
    ['shopify-pc__prefs__dialog', 'shopify-pc__banner__dialog'].forEach(function (id) {
      var d = document.getElementById(id);
      if (!d) return;
      d.style.setProperty('max-height', '94vh', 'important');
      d.style.setProperty('height', 'auto', 'important');
      d.style.setProperty('overflow', 'visible', 'important');
    });
    ['shopify-pc__prefs__scrollable', 'shopify-pc__prefs__intro', 'shopify-pc__banner__body'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
    });
  }

  zetKleuren();
  var obs = new MutationObserver(zetKleuren);
  obs.observe(document.documentElement, { childList: true, subtree: true });
  // Na een minuut is de banner er wel of niet; dan stoppen we met kijken.
  setTimeout(function () { obs.disconnect(); }, 60000);
})();

/* 16 okt: knop "Cookievoorkeuren" in de footer opent het voorkeurenscherm van Shopify. */
(function () {
  document.querySelectorAll('[data-tv-cookieprefs]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        e.preventDefault();
        window.privacyBanner.showPreferences();
      }
    });
  });
})();

